/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * featureFlags.ts — featur\1 \2lags (services/operator-web-app).
 */

/**
 * E8-S1: Feature flags for canary and rollback.
 * Read from env (VITE_FEATURE_*); defaults enable all features.
 * Rollback: set env to false and redeploy.
 */

function parseBool(value: string | undefined, defaultValue: boolean): boolean {
  if (value === undefined || value === '') return defaultValue;
  return value === '1' || value.toLowerCase() === 'true' || value === 'yes';
}

export type CallTransportProfile = 'websocket' | 'webrtc';

function parseTransport(value: string | undefined): CallTransportProfile {
  if (value === 'webrtc') return 'webrtc';
  return 'websocket';
}

const raw = {
  aiHints: import.meta.env.VITE_FEATURE_AI_HINTS as string | undefined,
  aiHighlights: import.meta.env.VITE_FEATURE_AI_HIGHLIGHTS as string | undefined,
  callTransport: import.meta.env.VITE_CALL_TRANSPORT as string | undefined,
  canaryCohort: import.meta.env.VITE_CANARY_COHORT as string | undefined,
};

/** AI hints panel (E6-S2). Disable for rollback or canary control. */
export const featureFlags = {
  aiHints: parseBool(raw.aiHints, true),
  aiHighlights: parseBool(raw.aiHighlights, true),
  callTransport: parseTransport(raw.callTransport),
  /** Optional cohort id for canary routing (sent in presence_register). */
  canaryCohort: raw.canaryCohort?.trim() || null,
} as const;

export function getFeatureFlags(): Readonly<typeof featureFlags> {
  return featureFlags;
}
